const MERGE_ENTITIES = 'ts/entities/MERGE_ENTITIES';

export default {
  MERGE_ENTITIES,
};
